export default "__VITE_ASSET__DKo_qSI7__"